const invalidPathValue = "Invalid path value";
export default invalidPathValue;
